import React, { FC } from 'react';
const Button: FC<buttonProp> = (props) => {
    return(
        <button type={props.type}
            id={props.id}
            style={props.style}
            className={props.className}
            disabled={props.disabled}
            onClick={props.onClick}
        >{props.children}</button>
    )
}
interface buttonProp{
    id?:string,
    children:React.ReactNode,
    className?:string,
    disabled?:boolean,
    onClick?(): void,
    style?:React.CSSProperties,
    type?:"submit" | "button" | "reset" 
}
Button.defaultProps={
    type:"button",
    className:"btn btn-primary",
    disabled:false
}
export {Button}